<template>
  <div :id="settings.id" class="flex cursor-pointer" @click="$emit('click', props.name)">
    <img :src="settings.image" alt="top-menu-item" />
    <div class="leading-9 ml-1.5 transition-colors hover:text-primary-main">
      {{ changeCase(settings.title, ElementE.TITLE) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { changeCase } from "../../helpers";
import { ElementE } from '../../enums';

interface PropsI {
  name: string,
  title: string,
}

const props = defineProps<PropsI>();
defineEmits(['click']);

const settings = computed(() => ({
  id: `top-menu-${props.name}`,
  image: require(`./assets/${props.name}.svg`),
  title: props.title,
}));
</script>
